export var IPCServers;
(function (IPCServers) {
    IPCServers["BLE"] = "BLE";
})(IPCServers = IPCServers || (IPCServers = {}));
export var IPCClients;
(function (IPCClients) {
    IPCClients["WebBleClient"] = "WebBleClient";
})(IPCClients = IPCClients || (IPCClients = {}));
